export function readFileWithProgress(
  file: File,
  onProgress: (percentage: number) => void
): Promise<void> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onprogress = (event: ProgressEvent<FileReader>) => {
      if (!event.lengthComputable || event.total === 0) return;
      onProgress(Math.min(99, Math.round((event.loaded * 100) / event.total)));
    };

    reader.onload = () => {
      onProgress(100);
      resolve();
    };

    reader.onerror = () => {
      reject(reader.error ?? new Error('Não foi possível ler o arquivo'));
    };

    reader.readAsArrayBuffer(file);
  });
}
